import { render, staticRenderFns } from "./FullscreenCamera.vue?vue&type=template&id=ea884fb8&"
import script from "./FullscreenCamera.vue?vue&type=script&lang=ts&"
export * from "./FullscreenCamera.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports